import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReportSchedules, updateActiveStep, clearFormValues } from '../../../../redux/slices/reports';
import ReportsScheduleModal from './ReportsScheduleModal';
import ReportTimeoutEmailPopup from '../results/ReportTimeoutEmailPopup';
import { getReportResultsMain } from '../ReportViewHelper';
import ReportResultTable from '../results/ReportResultTable';
import ReportScheduleTable from './ReportScheduleTable';
import LoadingAnimation from '../../../../reusable-components/loader/LoadingAnimation';

export default function ReportsScheduleView() {
  const dispatch = useDispatch();
  const { activeStep, formValues, selectedReportId, reportRecipients, loadingReportScheduleResults } = useSelector((state) => state.reports?.data);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState(null);
  const [openSidebar, setOpenSidebar] = useState(true);
  const [openTimeoutSendAsEmail, setOpenTimeoutSendAsEmail] = useState(false);

  const getReportResults = (download, sendAsEmail) =>
    getReportResultsMain(selectedReportId, dispatch, setOpenTimeoutSendAsEmail, formValues, download, sendAsEmail, () => dispatch(updateActiveStep(2)));

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
    setRow(null);
  };

  const getSchedules = () => dispatch(fetchReportSchedules());

  useEffect(() => {
    getSchedules();
  }, []);

  if (loadingReportScheduleResults) {
    return <LoadingAnimation />;
  }

  return (<>
    {openTimeoutSendAsEmail && <ReportTimeoutEmailPopup close={() => setOpenTimeoutSendAsEmail(false)} getReport={() => getReportResults(true, true)} />}
    {activeStep !== 2 && <ReportScheduleTable setEdit={setEdit} setRow={setRow} setOpen={setOpen} />}

    {activeStep === 2 && <ReportResultTable
      back={() => dispatch(updateActiveStep(1))}
      backText="Back to schedule"
      openSidebar={openSidebar}
      setOpenSidebar={setOpenSidebar}
      getReportResults={getReportResults}
      setOpenTimeoutSendAsEmail={setOpenTimeoutSendAsEmail}
      newReport={() => {
        setRow(null);
        dispatch(clearFormValues());
        dispatch(updateActiveStep(0));
        setEdit(false);
        setOpen(true);
      }}
    />}

    <ReportsScheduleModal
      row={row}
      handleClose={handleClose}
      open={open}
      getReportResults={getReportResults}
      refetchSchedules={getSchedules}
      edit={edit}
    />
  </>
  );
}